import React, { useState } from "react";
import SignUpBackGround from "../BackOfficeGeneralContainer/SignupPageBackGround";
import UserEditing from "./UserEditing";
import ManagementFooter from "../BackOfficeGeneralContainer/ManagementFooter";
const EditUsers = () => {
  const [submitted, setsubmitted] = useState(false);
  const submitHandler = () => {
    setsubmitted((state) => !state);
  };
  // const getEdited = (data) => {
  //   return data;
  // };
  const getURL = () => {
    if (window.location.pathname.includes("/mdr/userManagement/editUser")) {
      return "/mdr/userManagement";
    } else if (window.location.pathname.includes("/gov/userManagement/editUser")) {
      return "/gov/userManagement";
    } else {
      return "/tenant/userManagement";
    }
  }
  
  const project = window.location.pathname.includes("/mdr/userManagement/editUser") ? "MDR" : "DDV";
  return (
    <div className={project === "MDR" ? "MDR_EditingContainer" : "editingContainer"}>
      <SignUpBackGround
        headerName="User Editing"
        header="User Editing"
        breadcrumbValue={[
          {
            value: "User Management",
            link: getURL(),
          },
          { value: "Edit", link: "" },
        ]}
        // type="marginRequired"
        loc={project}
      ></SignUpBackGround>
      {UserEditing({ submitted: submitted })}
    </div>
  );
};

export default EditUsers;
